import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { Feature } from "../../models/feature.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import {
    PermissionLevel,
    permissionLevelsConstants,
} from "../../utils/constants/permission-levels.constants";

let FeatureSettingsDialog = {
    selector: "vcFeatureSettingsDialog",
    templateUrl:
        "/angular/components/profile/feature-settings-dialog.component.html",
    bindings: {
        feature: "=",
    },
    controller: class FeatureSettingsDialogController {
        // * bindings for typescript compiler *
        public feature: Feature;
        // ************************************

        public readonly permissionRows = permissionLevelsConstants.levels
            .filter(
                (level: PermissionLevel): boolean => level.featureKey !== null
            )
            .map((level: PermissionLevel) => ({
                id: level.permissionid,
                featureKey: level.featureKey,
                orgOnly: level.permissiontype === "ORGANISATION",
            }));

        public selectedAll = 0;
        public activeCampaign: Campaign;
        public isLeaderView: boolean;
        public isOrgCampaign: boolean;
        public featureDisabled = false;
        public featureDisabledMessage = "";

        private readonly $scope: any;
        private dialog: DialogUtils;

        private permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            PermissionCheck: PermissionCheck,
            CampaignDataProvider: CampaignDataProvider,
            __app_type: string
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;

            this.permissionProvider = PermissionCheck;

            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.isLeaderView = __app_type == "LEADER";
            this.isOrgCampaign =
                __app_type == "USER" &&
                this.activeCampaign.isOrganisationCampaign();
        }

        $onInit() {
            this.featureDisabled = this.featureIsDisabled(this.feature);
            this.$scope.$watchCollection(
                () => this.feature,
                (newValue: Feature) => {
                    if (!newValue) return;

                    let checks = this.checkAllPermission(
                        newValue,
                        this.isLeaderView
                    );
                    if (this.isLeaderView && checks === 7) {
                        this.selectedAll = 1;
                    } else if (!this.isLeaderView && checks === 5) {
                        this.selectedAll = 1;
                    } else {
                        this.selectedAll = 0;
                    }
                }
            );
        }

        featureIsDisabled(feature: Feature): boolean {
            if (this.isOrgCampaign) {
                this.featureDisabledMessage =
                    "This feature is configured at the organization level.";
                return true;
            }

            if (feature.id == "25") {
                return this.checkAutoGenerateContactNameFeature(feature);
            }

            return false;
        }

        checkAutoGenerateContactNameFeature(feature: Feature): boolean {
            const disabled =
                !feature.extra ||
                (typeof feature.extra.defaultFirstName === "undefined" &&
                    typeof feature.extra.firstNameAutoIncrement ===
                        "undefined") ||
                (typeof feature.extra.defaultLastName === "undefined" &&
                    typeof feature.extra.lastNameAutoIncrement === "undefined");
            this.featureDisabledMessage =
                "The settings for this feature must first be configured.";
            return disabled;
        }

        Cancel(): void {
            this.dialog.cancel();
        }

        Confirm(): void {
            this.dialog.hide(this.feature);
        }

        // Select all checkbox
        selectManager(value: any): void {
            Object.keys(this.feature).map((key: string) => {
                if (
                    key === "campaignmanager" &&
                    !this.featurePermissionDisabled(this.feature, 3)
                ) {
                    this.feature[key] = value;
                } else if (
                    key === "campaignstaffer" &&
                    !this.featurePermissionDisabled(this.feature, 4)
                ) {
                    this.feature[key] = value;
                } else if (
                    key === "canvasser" &&
                    !this.featurePermissionDisabled(this.feature, 6)
                ) {
                    this.feature[key] = value;
                } else if (
                    key === "leadcanvasser" &&
                    !this.featurePermissionDisabled(this.feature, 5)
                ) {
                    this.feature[key] = value;
                } else if (
                    key === "organisationleader" &&
                    !this.featurePermissionDisabled(this.feature, 9) &&
                    this.isLeaderView
                ) {
                    this.feature[key] = value;
                } else if (
                    key === "organisationowner" &&
                    !this.featurePermissionDisabled(this.feature, 8) &&
                    this.isLeaderView
                ) {
                    this.feature[key] = value;
                } else if (
                    key === "divisionmanager" &&
                    !this.featurePermissionDisabled(this.feature, 10) &&
                    this.isLeaderView
                ) {
                    this.feature[key] = value;
                } else if (
                    key === "owner" &&
                    !this.featurePermissionDisabled(this.feature, 2)
                ) {
                    this.feature[key] = value;
                }
            });
        }

        checkAllPermission(feature: any, isOrg: boolean): number {
            let count = 0;
            Object.keys(feature).map((key: string) => {
                if (isOrg) {
                    if (
                        (key === "campaignmanager" && feature[key] === 1) ||
                        (key === "campaignstaffer" && feature[key] === 1) ||
                        (key === "organisationleader" && feature[key] === 1) ||
                        (key === "organisationowner" && feature[key] === 1) ||
                        (key === "canvasser" && feature[key] === 1) ||
                        (key === "leadcanvasser" && feature[key] === 1) ||
                        (key === "owner" && feature[key] === 1)
                    ) {
                        count = count + 1;
                    }
                } else {
                    if (
                        (key === "campaignmanager" && feature[key] === 1) ||
                        (key === "campaignstaffer" && feature[key] === 1) ||
                        (key === "canvasser" && feature[key] === 1) ||
                        (key === "leadcanvasser" && feature[key] === 1) ||
                        (key === "owner" && feature[key] === 1)
                    ) {
                        count = count + 1;
                    }
                }
            });
            return count;
        }

        featurePermissionDisabled(
            feature: Feature,
            featurePermissionID: number
        ): boolean {
            return feature.disabled(
                this.permissionProvider.permissionid,
                featurePermissionID.toString()
            );
        }
    },
};

angular
    .module("profile")
    .component(FeatureSettingsDialog.selector, FeatureSettingsDialog);
